import { useMemo } from "react";

import { Redirect } from "react-router-dom";
import { AppModel } from "@doitintl/cmp-models";
import { getCollection } from "@doitintl/models-any";
import { useDocument } from "@doitintl/models-hooks";
import { Box } from "@mui/material";

import { useCustomerId } from "../../Components/hooks/useCustomerId";
import { type ContractsPageId } from "../../Navigation/config/pages";
import ContractForm from "../Contracts/ContractForm/ContractForm";
import ContractPage from "../Contracts/ContractView/ContractPage";
import VendorContractPage from "../Contracts/VendorContractView/VendorContractPage";
import { ContractsListTab } from "./Contracts";
import { ContractTypesContextProvider } from "./ContractsTypesContext";

type Props = {
  pageId: ContractsPageId;
};

export const ContractsTabs = (props: Props) => {
  const { pageId } = props;
  const customerId = useCustomerId();
  const [appContracts] = useDocument(getCollection(AppModel).doc("contracts"));

  const gotoMainContracts = useMemo(() => ["contracts", "contracts:list"].includes(pageId), [pageId]);

  if (["contracts:create", "contracts:edit"].includes(pageId) && appContracts?.asModelData()?.disableEditing) {
    return <Redirect to={`/customers/${customerId}/billing/contracts`} />;
  }

  return (
    <ContractTypesContextProvider>
      <Box
        sx={{
          ml: -1,
        }}
      >
        {gotoMainContracts && <ContractsListTab {...props} />}
        {(pageId === "contracts:create" || pageId === "contracts:edit") && <ContractForm {...props} />}

        {pageId === "contracts:view" && <ContractPage />}

        {pageId === "contracts:view-vendor-contract" && <VendorContractPage />}
      </Box>
    </ContractTypesContextProvider>
  );
};
